import { render, staticRenderFns } from "./EditTeacherSubject.vue?vue&type=template&id=a3b417ae&"
import script from "./EditTeacherSubject.vue?vue&type=script&lang=ts&"
export * from "./EditTeacherSubject.vue?vue&type=script&lang=ts&"
import style0 from "./EditTeacherSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports